import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import StatCard from '../components/StatCard';
import Chart from '../components/Chart';
import { useAuth } from '../context/AuthContext';

interface Stats {
  totalMinted: number;
  totalVerifications: number;
  failedVerifications: number;
  burnedItems: number;
  blacklistedItems: number;
  avgApiCallsPerMinute: number;
}

// Mock data for now — will wire to real API once auth endpoints are built
const mockStats: Stats = {
  totalMinted: 1842,
  totalVerifications: 24601,
  failedVerifications: 47,
  burnedItems: 203,
  blacklistedItems: 12,
  avgApiCallsPerMinute: 8.4,
};

const mockChartData = [
  { label: 'Mon', value: 3200 },
  { label: 'Tue', value: 4100 },
  { label: 'Wed', value: 3800 },
  { label: 'Thu', value: 5200 },
  { label: 'Fri', value: 4700 },
  { label: 'Sat', value: 2900 },
  { label: 'Sun', value: 3600 },
];

const mockDupeData = [
  { label: 'Mon', value: 4 },
  { label: 'Tue', value: 9 },
  { label: 'Wed', value: 6 },
  { label: 'Thu', value: 11 },
  { label: 'Fri', value: 8 },
  { label: 'Sat', value: 3 },
  { label: 'Sun', value: 6 },
];

export default function StudioDashboard() {
  const { user } = useAuth();
  const [stats] = useState<Stats>(mockStats);

  return (
    <div className="min-h-screen bg-gray-950">
      <Navbar />
      <div className="max-w-7xl mx-auto px-8 py-10">

        <div className="mb-8">
          <h2 className="text-2xl font-bold text-white">Dashboard</h2>
          <p className="text-gray-400 mt-1">Game ID: {user?.gameId ?? 'GAME_001'}</p>
        </div>

        {/* Stat Cards */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8">
          <StatCard
            label="Total Items Minted"
            value={stats.totalMinted.toLocaleString()}
            color="blue"
          />
          <StatCard
            label="Verifications Run"
            value={stats.totalVerifications.toLocaleString()}
            color="green"
          />
          <StatCard
            label="Dupes Caught"
            value={stats.failedVerifications.toLocaleString()}
            sub="ownership_mismatch events"
            color="red"
          />
          <StatCard
            label="Items Burned"
            value={stats.burnedItems.toLocaleString()}
            color="gray"
          />
          <StatCard
            label="Items Blacklisted"
            value={stats.blacklistedItems.toLocaleString()}
            color="yellow"
          />
          <StatCard
            label="Avg API Calls/Min"
            value={stats.avgApiCallsPerMinute}
            color="blue"
          />
        </div>

        {/* Charts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <Chart
            data={mockChartData}
            title="Verifications This Week"
            color="#3b82f6"
          />
          <Chart
            data={mockDupeData}
            title="Dupes Caught This Week"
            color="#ef4444"
          />
        </div>

        {/* API Key */}
        <div className="bg-gray-900 rounded-xl p-6 shadow-lg">
          <p className="text-gray-300 font-semibold mb-3">API Key</p>
          <div className="flex items-center gap-3">
            <code className="bg-gray-800 text-green-400 px-4 py-2 rounded-lg text-sm flex-1">
              {user?.apiKey ?? 'gc_live_test_key_001'}
            </code>
            <button
              onClick={() => navigator.clipboard.writeText(user?.apiKey ?? 'gc_live_test_key_001')}
              className="bg-gray-700 hover:bg-gray-600 text-white text-sm px-4 py-2 rounded-lg transition"
            >
              Copy
            </button>
          </div>
          <p className="text-gray-500 text-xs mt-2">Keep this key private. Pass it as x-api-key in all API requests.</p>
        </div>

      </div>
    </div>
  );
}